import { SVGProps } from 'react';

export const KeenableIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 138 138"
    {...props}
  >
    <path
      fill="#fff"
      d="M48.05 37.28q6.39 0 11.83 3.1a26.6 26.6 0 0 1 8.97 8.38 26 26 0 0 1 4.4 11.65H22.77q1.12-6.47 4.66-11.74a26 26 0 0 1 8.9-8.28 23 23 0 0 1 11.73-3.11"
    />
    <circle cx="54.02" cy="55.96" r="14.15" fill="#2a2a2a" />
    <path
      fill="#005cff"
      fillRule="evenodd"
      d="M44.3 22q10.1 0 18.61 4.16a43 43 0 0 1 14.53 11.52 48 48 0 0 1 8.87 17.02 53 53 0 0 1 1.77 20.29l-35.1.02c-22.74.02-29.4 31.03-8.68 40.38a41.4 41.4 0 0 1-22.32-6.29A47 47 0 0 1 5.94 92.27 47.4 47.4 0 0 1 0 68.79q0-9.75 3.46-18.17a48 48 0 0 1 9.48-14.89 45 45 0 0 1 14.17-10.1A41 41 0 0 1 44.31 22m3.73 15.28q-6.39 0-11.74 3.1a26 26 0 0 0-8.89 8.3 30 30 0 0 0-4.66 11.73h50.5a26 26 0 0 0-4.4-11.65 26.6 26.6 0 0 0-8.98-8.37 23.4 23.4 0 0 0-11.83-3.11"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M96.64 37.28q6.39 0 11.83 3.1a26.6 26.6 0 0 1 8.97 8.38 26 26 0 0 1 4.4 11.65h-50.5q1.14-6.47 4.67-11.74a26 26 0 0 1 8.89-8.28 23 23 0 0 1 11.74-3.11"
    />
    <circle cx="108.67" cy="55.96" r="14.15" fill="#2a2a2a" />
    <path
      fill="#005cff"
      fillRule="evenodd"
      d="M93.94 22q10.1 0 18.6 4.16a43 43 0 0 1 14.54 11.52 48 48 0 0 1 8.86 17.02 53 53 0 0 1 1.77 20.29h-35.06c-22.76 0-29.45 31.03-8.71 40.4a41.4 41.4 0 0 1-22.33-6.29 47 47 0 0 1-16.04-16.83 47.4 47.4 0 0 1-5.94-23.48q0-9.75 3.46-18.17a48 48 0 0 1 9.48-14.89 45 45 0 0 1 14.18-10.1A41 41 0 0 1 93.94 22m2.7 15.28q-6.39 0-11.74 3.1a26 26 0 0 0-8.89 8.3 30 30 0 0 0-4.66 11.73h50.5a26 26 0 0 0-4.4-11.65 26.6 26.6 0 0 0-8.98-8.37 23.4 23.4 0 0 0-11.83-3.11"
      clipRule="evenodd"
    />
  </svg>
);
